<template>
  <div class="leftbig">
    <div class="leftTop">旭德简介</div>
    <div class="menu">
      <el-menu
        style="border-right: 0px"
        :default-active="
          '/' + $route.path.split('/')[1] + '/' + $route.path.split('/')[2]
        "
        @select="handleSelect"
      >
        <el-menu-item index="/information/introduction">
          <i class="el-icon-menu"></i>
          <span slot="title">旭德简介</span>
        </el-menu-item>
        <el-menu-item index="/information/distribution">
          <i class="el-icon-menu"></i>
          <span slot="title">网点分布</span>
        </el-menu-item>
        <el-menu-item index="/information/video">
          <i class="el-icon-menu"></i>
          <span slot="title">宣传视频</span>
        </el-menu-item>
        <el-menu-item index="/information/CompanyStatic">
          <i class="el-icon-menu"></i>
          <span slot="title">公司动态</span>
        </el-menu-item>
        <el-menu-item index="/information/contactus">
          <i class="el-icon-menu"></i>
          <span slot="title">联系我们</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="applet">
      <img :src="this.$store.state.QRcode[0]" alt="小程序" />
    </div>
    <div class="oneToOne" @click="goOneToOne">
      <img src="../../../assets/img/oneToOne.png" alt="1对1服务" />
    </div>
  </div>
</template>

<script>
import { getAdvertisementDetail } from "@/api";
export default {
  data() {
    return {
      active: "", //激活项
      QRcode: [],
    };
  },
  mounted() {
    this.handleSelect("1");
    this.getQRcode();
  },
  methods: {
    goOneToOne(){
      this.$router.push("/volunterservce/oneServe");
    },
    handleSelect(key, keyPath) {
      this.$emit("gettype", key);
    },
    // 小程序图片
    async getQRcode() {
      let res = await getAdvertisementDetail({ id: 8 });
      if (res.code == 1) {
        this.QRcode = res.data.images;
      }
    },
  },
};
</script>

<style lang="less" scoped>


.oneToOne:hover{
  img{
    transform: scale(1.2);
  }
}
.leftbig {
  width: 260px;
  .leftTop {
    background: url(../../../assets/img/leftmune_top_bg.jpg) center top
      no-repeat;
    border-radius: 5px;
    background-position: 100% auto;
    height: 106px;
    text-align: center;
    line-height: 106px;
    font-size: 30px;
    font-weight: bold;
    color: #fff;
  }
  .menu {
    width: 100%;
    /deep/.el-menu-item {
      font-size: 16px !important;
    }
    /deep/.el-menu-item.is-active {
      color: #1ab394 !important;
    }
    /deep/.el-menu-item:focus,
    .el-menu-item:hover {
      outline: 0;
      background-color: #fff;
      color: #1ab394 !important;
    }
  }
  .applet {
      width: 100%;
      img {
        width: 160px;
        margin-left: 50px;
      }
    }
}
</style>
